import tw from 'twin.macro';

export const MenuWrapper = tw.div`flex items-center justify-evenly w-full h-full rounded-xl p-3 px-0.5`;
